export function parseCurrencyMask (raw) {
  const digits = String(raw || '').replace(/\D/g, '')
  if (!digits) return 0
  return Number(digits) / 100
}

export function formatCurrencyMask (value, locale = 'pt-BR') {
  const n = Number(value || 0)
  const loc = locale?.startsWith('en') ? 'en-US' : locale?.startsWith('es') ? 'es-ES' : 'pt-BR'
  return n.toLocaleString(loc, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export function formatCurrencyMaskFromInput (value, locale = 'pt-BR') {
  const parsed = parseCurrencyMask(value)
  return parsed > 0 ? formatCurrencyMask(parsed, locale) : ''
}
